import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import * as XLSX from 'xlsx';
import { TableService } from '../../services/tableService/table.service';

@Component({
  selector: 'app-export-to-excel',
  standalone: false,
  templateUrl: './export-to-excel.component.html',
  styleUrl: './export-to-excel.component.scss'
})
export class ExportToExcelComponent {
  @ViewChild('container') content: ElementRef | any;
  @Input() data:any;
  private spread:any;
  private subscription:any;
  public exportPDFTableList:any;

  constructor(public appService:AppService, public tableService:TableService) {
    this.subscription = this.appService.fileExportEmit.subscribe((evt:any) =>{      
      this.onSaveExcel();
    })
    appService.isLoading=true;
    setTimeout(() => {
      this.exportPDFTableList = this.appService.exportPDFTableList; 
      appService.isLoading=false;    
    }, 5000);
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data']?.currentValue){
      this.data = changes['data'].currentValue;
    }
  }

  onSaveExcel() {
    this.subscription.unsubscribe();
    const content = this.content.nativeElement;
    const workbook = XLSX.utils.table_to_book(content, { sheet: 'Sheet1' });
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = this.data?.RateAgreementNumber+'.xlsx';

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = fileName;
    link.click();

  }

  delayRender(index: number) {
    setTimeout(() => {
      // Access the specific item in exportPDFTableList based on the index and render the appropriate component
      const item = this.appService.exportPDFTableList[index];
      if (item.type === 'ltl') {
        // Render app-export-pdf-ltl component
      } else if (item.type === 'fixed') {
        // Render app-export-pdf-fixed component
      } else if (item.type === 'ftl') {
        // Render app-export-pdf-table component
      }
    }, 1000 * index); // Delay each item based on its index position
  }
}
